import { Link } from "@tanstack/react-router";
import { formatMonitoringPercent, type RailwayScope, type RailwayShareItem } from "../monitoring-page.lib";

type RailwayShareRowProps = {
  item: RailwayShareItem;
  scope: RailwayScope;
};

export const RailwayShareRow = ({ item, scope }: RailwayShareRowProps) => {
  const percent = Math.min(Math.max(item.percent, 0), 100);

  return (
    <Link
      to="/"
      search={{ monitoringMetric: scope === "active" ? "ACTIVE" : "TOTAL", railway: item.id }}
      className="hover:bg-neutrals-99 flex w-full items-center justify-between rounded-lg"
    >
      <p className="paragraph-base text-type-common w-[15.625rem] shrink-0 truncate">{item.name}</p>
      <div className="flex min-w-[15rem] shrink-0 items-center justify-end gap-4">
        <div className="bg-neutrals-90 relative flex h-4 w-[12.5rem] items-center overflow-hidden rounded-lg">
          <div className="bg-system-success-50 h-full min-w-px shrink-0" style={{ width: `${percent}%` }} />
          <p className="caption-xs text-type-common absolute right-1 whitespace-nowrap text-right">{formatMonitoringPercent(item.percent)}</p>
        </div>
        <p className="paragraph-base text-type-common min-w-[1.875rem] text-right">{item.count}</p>
      </div>
    </Link>
  );
};
